import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-onboarding-success-page',
  templateUrl: './onboarding-success-page.component.html',
  styleUrls: ['./onboarding-success-page.component.scss']
})
export class OnboardingSuccessPageComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  sub: any;
  orgId: number;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/onboarding-success-page/onboarding-success-page.component.ts